@use '~/theme/theme' as *;
@use '~/theme/typography';

.container {
  border-radius: spacing(2);
  background-color: white;
  padding-top: spacing(3);
  padding-bottom: spacing(5);
  font-style: 0;
  display: flex;
  flex-direction: column;

  &::before {
    content: '';
    float: left;
  }
}

.previewBody {
  padding-left: spacing(5);
  padding-right: spacing(5);
  display: flex;
  flex-direction: column;
}

.topRow {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.fromContainer {
  display: flex;
  gap: spacing(2);
}

.fromTo {
  display: flex;
  gap: spacing(5);
  margin-top: spacing(5);
  margin-bottom: spacing(5);
}

.companyInfo {
  display: flex;
  flex-direction: column;
  gap: spacing(2);
}

.paymentInfo {
  display: flex;
  gap: spacing(3);
  margin-top: spacing(3);
  flex-wrap: wrap;
}

.keyValue {
  display: flex;
  flex-wrap: wrap;
  gap: spacing(1);
  align-items: flex-start;
}

.value {
  flex: 1;
}

.itemsTable {
  margin-top: spacing(5);
  overflow-x: unset;

  thead {
    background: color(grey-100);

    th {
      color: color(grey-600);
      padding: 6px 16px;

      @include typography.caption;
      @include typography.semibold;

      vertical-align: middle;
    }
  }

  tbody {
    td {
      padding: 6px 16px;

      @include typography.body2;
      @include typography.regular;
    }
  }
}

.totalsContainer {
  display: grid;
  flex-direction: column;
  grid-template-columns: 1fr auto;
  column-gap: spacing(3);
  margin-top: spacing(6);
  color: color(grey-800);
  align-items: center;
  min-width: 340px;
  align-self: flex-end;
}

.divider {
  border-top: border(grey-400);
  border-top-style: solid;
  grid-column: 1 / 3;
  border-bottom: none;
  border-left: none;
  border-right: none;
  margin-top: spacing(1.5);
  margin-bottom: spacing(1.5);
}

.lawReference {
  grid-column: 1 / 3;
}

.total {
  color: color(grey-800);
}

.amount {
  text-align: right;
}

.logo {
  max-width: 160px;
  max-height: 80px;
  width: 100%;
}

.section {
  margin-top: spacing(3);
}

.row {
  display: flex;
  align-items: center;
  gap: spacing(3);
  margin-top: spacing(1);
}

.notes {
  white-space-collapse: preserve;
}

.transportInformationContainer {
  display: flex;
  flex-direction: column;
  gap: spacing(2);
}

.transportInformationLine {
  display: flex;
  gap: spacing(2);
}

.deliveryNoteSignatures {
  position: relative;
  padding: 0 spacing(5) spacing(5.75);
  display: flex;
  justify-content: space-between;
}

.centralSpacer {
  flex-grow: 1;
  min-height: 300px;
}

.ddtContainer {
  display: grid;
  grid-template-columns: max-content max-content;
  gap: spacing(1) spacing(3);
}

.taxableDetail {
  padding-top: spacing(1.5);
}
